<template>
  <table>

    <tr>
      <div class="message" :class="{ 'from-user': owner }">
        <img @click="setVote(1)" style="height: 25px" src="../assets/up.png"> {{message.votes}} <img @click="setVote(0)" style="height: 25px" src="../assets/down.png"> {{ message.text }}
        <br />

        <audio v-if="message.audioURL" :src="message.audioURL" controls></audio>
        <br />

        
        <span class="sender">made by 
          <router-link :to="{ name: 'profile', params: { uid: message.sender } }">
            {{ displayName.userName }}
          </router-link> on page {{message.page}}/<a @click="showComments">{{showComment}} {{messages.length}} replies</a>/
          <a class="comment" @click="subComment">{{comCancel}}</a> 
        </span>
        
      </div>
    </tr>


   
    <!-- <tr v-for="comment of message.comments" :key="comment.id">
      <MessageComment :message="comment" :owner="yourId === message.sender" />
    </tr> -->

    <div v-if="numTest === 1" class="columns, panel-block" style="background: violet;">
      <div class="column">
          
          <audio v-if="newAudio" :src="newAudioURL" controls></audio>
          <h5 v-else>Record Audio</h5>

          <button v-if="!recorder" @click="record()" class="button is-info">Record Voice</button>
          <button v-else @click="stop()" class="button is-danger">Stop</button>

          <br />

          
      </div>

      <div class="column">


          <input v-model="newMessageText" class="input" />

          <button
            :disabled="(!newMessageText && !newAudio) || loading"
            class="button is-success"
            type="text"
            @click="addMessage(yourId)"
          >Comment</button>
      </div>
      
    </div>

    <div v-if="showComment === 'Hide'">
      <li v-for="messag of messages" :key="messag.id">
        <MessageComment :message="messag" :owner="yourId === messag.sender" :prevRef="message.messageId" :yourId="yourId" :currentPage="currentPage" /> 
      </li>
    </div>

  </table>
  
  
</template>

<script>
import { db, storage } from '../firebase';
import MessageComment from './MessageComment';
import swal from 'sweetalert';

export default {
    components: {
      MessageComment
    },
    data() {
      return { 
            displayName: '',
            numTest: 0,
            newAudio: null,
            recorder: null,
            newMessageText: '',
            comCancel: 'Comment',
            loading: false,
            messages: [],
            showComment: 'View',
            voteReg: null
      }
    },
    firestore() {
      return {
        displayName: this.userName,
        messages: this.messagesCollection.orderBy('votes', 'desc'),
        voteReg: this.voteVerify.doc(`${this.message.messageId}`)
      };
    },
    props: ['message', 'owner' , 'yourId', 'currentPage'],
    computed: {
      chatId() {
        return this.$route.params.id;
      },
      userName(){
        return db.doc(`users/${this.message.sender}`)
      },
      newAudioURL() {
        return URL.createObjectURL(this.newAudio);
      },
      messagesCollection() {
        return db.doc(`chats/${this.chatId}/messages/${this.message.messageId}`).collection('messages');
      },
      votes() {
        return db.doc(`chats/${this.chatId}/messages/${this.message.messageId}`)
      },
      voteVerify(){
        return db.doc(`users/${this.yourId}/votes/${this.chatId}`).collection('comments');
      }
    },
    methods: {
      async setVote(arrow){
        let ref = this.message.messageId;

        if(this.message.sender !== this.yourId){
          if(arrow === 1){
            if(this.voteReg === null){
              await this.voteVerify.doc(ref).set({
                vote: 2,
                createdAt: Date.now()
              });
              let n = this.message.votes + 1;
              await this.votes.update({
                votes: n
              });
            }
            else if(this.voteReg.vote === 1){
              await this.voteVerify.doc(ref).set({
                vote: 2,
                createdAt: Date.now()
              });
              let n = this.message.votes + 1;
              await this.votes.update({
                votes: n
              });
            }
            else if(this.voteReg.vote === 0){
              await this.voteVerify.doc(ref).set({
                vote: 1,
                createdAt: Date.now()
              });
              let n = this.message.votes + 1;
              await this.votes.update({
                votes: n
              });
            }
          }
          if(arrow === 0){
            if(this.voteReg === null){
              await this.voteVerify.doc(ref).set({
                vote: 0,
                createdAt: Date.now()
              });
              let n = this.message.votes - 1;
              await this.votes.update({
                votes: n
              });
            }
            else if(this.voteReg.vote === 1){
              await this.voteVerify.doc(ref).set({
                vote: 0,
                createdAt: Date.now()
              });
              let n = this.message.votes - 1;
              await this.votes.update({
                votes: n
              });
            }
            else if(this.voteReg.vote === 2){
              await this.voteVerify.doc(ref).set({
                vote: 1,
                createdAt: Date.now()
              });
              let n = this.message.votes - 1;
              await this.votes.update({
                votes: n
              });
            }
          }
        }
        else{
          swal("Sorry", "You can't vote on your own comment.", "warning");
        }
      },
      showComments(){
        if(this.showComment === 'View'){
          this.showComment = 'Hide'
        }
        else{
          this.showComment = 'View'
        }
      },
      subComment(){
        if(this.numTest === 0){
          this.numTest = 1;
          this.comCancel = 'Cancel';
        }
        else{
          this.numTest = 0;
          this.comCancel = 'Comment';
        }
      },
      async addMessage(uid) {

        this.loading = true;

        let audioURL = null;

        const { id: messageId } = this.messagesCollection.doc();

        if (this.newAudio) {
          const storageRef = storage
            .ref('chats')
            .child(this.chatId)
            .child(`${messageId}.wav`);

            await storageRef.put(this.newAudio);

          audioURL = await storageRef.getDownloadURL();
        }


         await this.messagesCollection.doc(messageId).set({
            text: this.newMessageText,
            sender: uid,
            createdAt: Date.now(),
            audioURL,
            page: this.currentPage,
            messageId: messageId,
            votes: 0
        });

        this.loading = false;
        this.newMessageText = '';
        this.newAudio = null;
        this.numTest = 0;
        this.comCancel = 'Comment';
        this.showComment = 'Hide';

        // if(this.message.comments){
        //   this.message.comments.push(
        //     {
        //       text: this.newMessageText,
        //       sender: uid,
        //       createdAt: Date.now(),
        //       page: this.currentPage
        //     }
        //   )
        //   this.numTest = 0;
        //   this.comCancel = 'Comment';
        // }
        // else {
        //   this.message.comments = [];
        //   this.message.comments.push(
        //     {
        //       text: this.newMessageText,
        //       sender: uid,
        //       createdAt: Date.now()
        //     }
        //   );
        //   this.numTest = 0;
        //   this.comCancel = 'Comment';
        // }

      },
      async record() {
        this.newAudio = null;

        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: false
        });

        const options = { mimeType: "audio/webm" };
        const recordedChunks = [];
        this.recorder = new MediaRecorder(stream, options);

        this.recorder.addEventListener("dataavailable", e => {
          if (e.data.size > 0) {
            recordedChunks.push(e.data);
          }
        });

        this.recorder.addEventListener("stop", () => {
          this.newAudio = new Blob(recordedChunks);
          console.log(this.newAudio);
        });

        this.recorder.start();
      },
      async stop() {
        this.recorder.stop();
        this.recorder = null;
      },
    }

};
</script>
<style>
.message {
  background: #dddddd;
  color: black;
  width: 100%;
  border-radius: 5px;
  padding: 12px;
  display: inline-block;
}
.from-user {
  background: #91bbff;
}
.sender {
  font-size: 0.5rem;
}


</style>
